let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6dDCB")).then(() => parcelRequire('37m2U'));